import LinkedNoteResolver from '@/components/common/notes/linked-note-resolver/linked-note-resolver';
import GlobalNoteStandard from '@/components/common/notes/global-note-standard/global-note-standard';
import GlobalNoteTraceability from '@/components/common/notes/global-note-traceability/global-note-traceability';

const MC_NOTE_HISTORY = 'MCNoteHistory';
const LINKED_NOTE_TITLE = '__LINKED_NOTE__';

interface Props {
    note: any;
}

const GlobalNoteResolver = ({ note }: Props) => {
    if (note?.data?.customFields?.forms?._note_?.title?.includes(LINKED_NOTE_TITLE)) {
        return <LinkedNoteResolver note={note} />;
    }

    console.log('GLOBAL_NOTE_RESOLVER', note['@type']);

    return note['@type'] === MC_NOTE_HISTORY ? (
        <GlobalNoteStandard note={note} />
    ) : (
        <GlobalNoteTraceability note={note} />
    );
};

export default GlobalNoteResolver;
